import axios from '@/lib/axios';
import ForgotPasswordParams from '../types/ForgotPasswordParams';

const forgotPassword = (data: ForgotPasswordParams) => {
  return axios.post('/customer/forgot_password', data);
}

export default forgotPassword;